<style lang="scss">
/* ===== PC Layout Container ===== */
.page-inner {
    max-width: 1200px;
    margin: 0 auto;
}

/* ===== Modal Width Override ===== */
:deep(.ant-modal) {
    max-width: none !important;
}

.not-developer-praent {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
}

.not-developer-div {
    padding: 2rem;
    width: fit-content;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    text-align: center;
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
    }

    p {
        font-size: 1.1rem;
        color: #1a1a1a;
        margin-bottom: 1.5rem;
    }
}

/* ===== Info Card ===== */
.deveploer-content {
    border-radius: 8px;
    margin-bottom: 12px;

    :deep(.ant-card-head) {
        border-bottom: 1px solid #f0f0f0;
        padding: 0 16px;
        min-height: 48px;
    }

    :deep(.ant-card-body) {
        padding: 16px;
    }
}

.plugin-count {
    font-size: 15px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.88);
    margin-bottom: 16px;
    padding-left: 12px;
    border-left: 4px solid #1677ff;
}

.plugin-selector {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    gap: 8px;

    .selector-label {
        font-size: 13px;
        color: rgba(0, 0, 0, 0.65);
    }
}

/* ===== Stat Table ===== */
.stat-table-pc {
    border-radius: 8px;
    overflow: hidden;
}

/* ===== Mobile Card List ===== */
.stat-card-list {
    display: none;
    flex-direction: column;
    gap: 12px;

    .stat-mobile-card {
        border-radius: 10px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

        :deep(.ant-card-body) {
            padding: 12px 14px;
        }
    }

    .mobile-card-head {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 10px;
        padding-bottom: 8px;
        border-bottom: 1px solid #f0f0f0;
        font-weight: 600;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.88);
    }

    .mobile-card-body {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .mobile-field {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
    }

    .mobile-label {
        color: rgba(0, 0, 0, 0.45);
        min-width: 64px;
        flex-shrink: 0;
        font-size: 12px;
    }

    .mobile-value {
        color: rgba(0, 0, 0, 0.88);
        flex: 1;
        font-weight: 500;
    }
}

/* ===== Chart Canvas ===== */
.canvas-div {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 16px;

    .chart-box {
        width: 100%;
        height: 300px;
    }
}

.chart-card {
    border-radius: 8px;

    :deep(.ant-card-head) {
        border-bottom: 1px solid #f0f0f0;
        padding: 0 16px;
        min-height: 48px;
    }

    :deep(.ant-card-body) {
        padding: 16px;
    }
}

/* ===== Mobile Responsive ===== */
@media screen and (max-width: 768px) {
    .ant-layout-content {
        padding: 12px !important;
    }

    /* Toggle */
    .stat-table-pc {
        display: none !important;
    }

    .stat-card-list {
        display: flex !important;
    }

    .plugin-count {
        font-size: 14px;
        margin-bottom: 12px;
    }

    .plugin-selector {
        flex-wrap: wrap;
        margin-bottom: 12px;

        .ant-select {
            margin-left: 0 !important;
        }
    }

    .deveploer-content :deep(.ant-card-head) {
        padding: 0 12px;
        min-height: 44px;
    }

    .deveploer-content :deep(.ant-card-body) {
        padding: 12px;
    }

    .canvas-div {
        gap: 12px;
        margin-top: 12px;
    }

    .chart-card :deep(.ant-card-body) {
        padding: 12px;
    }

    .not-developer-div {
        padding: 1.5rem;

        p {
            font-size: 0.95rem;
        }
    }
}

/* Very small phones */
@media screen and (max-width: 480px) {
    .ant-layout-content {
        padding: 8px !important;
    }

    .not-developer-div {
        padding: 1rem;

        p {
            font-size: 0.9rem;
            margin-bottom: 1rem;
        }
    }
}
</style>
<template>
    <a-layout style="min-height: 100vh;">
        <UserHead />
        <a-layout>
            <a-layout-header style="padding: 0; background: #fff; border-bottom: 1px solid #f0f0f0;">
                <HeadTop />
            </a-layout-header>
            <a-layout-content class="page-content" style="padding: 24px; background: #f5f7fa;">
                <div class="page-inner">
                    <div v-if="isDeveloper == 0" class="not-developer-praent">
                        <div class="not-developer-div">
                            <p>您还不是开发者，暂时无法查看本页面喔~</p>
                            <div style="text-align: center; width: fit-content; margin: 1.5rem auto 0.5rem;">
                                <a-button type="primary" @click="goApiUrl">成为开发者</a-button>
                            </div>
                        </div>
                    </div>

                    <template v-if="isDeveloper == 1">
                        <!-- 开发者统计信息 -->
                        <a-card :bordered="false" class="deveploer-content">
                            <template #title>
                                <div class="plugin-count">您累计开发插件个数：{{ deveploerData.num }}</div>
                            </template>
                            <div class="plugin-selector">
                                <span class="selector-label">查看指定插件数据</span>
                                <a-select v-model:value="select_includes" allowClear placeholder="请选择插件"
                                    style="width: 160px;" @change="getIncludesData(select_includes)">
                                    <a-select-option label="全部插件" :value="-1" />
                                    <a-select-option v-for="item in deveploerData.list" :key="item.id"
                                        :value="item.id">{{ item.name ||
                                            item.includes_name }}</a-select-option>
                                </a-select>
                            </div>

                            <!-- PC端统计表格 -->
                            <a-table class="stat-table-pc" :data-source="statDataList" :pagination="false" row-key="key"
                                :scroll="{ x: 600 }" size="small" bordered :columns="statColumns">
                                <template #bodyCell="{ column, record }">
                                    <template v-if="column.key === 'label'">
                                        <span style="display: inline-flex; align-items: center; gap: 6px;">
                                            <component :is="record.icon"
                                                :style="{ color: record.iconColor, fontSize: '16px' }" />
                                            <strong>{{ record.label }}</strong>
                                        </span>
                                    </template>
                                </template>
                            </a-table>

                            <!-- 手机端统计卡片列表 -->
                            <div class="stat-card-list" v-if="statDataList && statDataList.length > 0">
                                <a-card v-for="record in statDataList" :key="record.key" class="stat-mobile-card"
                                    :bordered="false">
                                    <div class="mobile-card-head">
                                        <component :is="record.icon"
                                            :style="{ color: record.iconColor, fontSize: '16px', marginRight: '6px' }" />
                                        {{ record.label }}
                                    </div>
                                    <div class="mobile-card-body">
                                        <div class="mobile-field">
                                            <span class="mobile-label">今日</span>
                                            <span class="mobile-value">{{ getValue(record, 'today') }}（元/个）</span>
                                        </div>
                                        <div class="mobile-field">
                                            <span class="mobile-label">昨日</span>
                                            <span class="mobile-value">{{ getValue(record, 'yesterday') }}（元/个）</span>
                                        </div>
                                        <div class="mobile-field">
                                            <span class="mobile-label">共计</span>
                                            <span class="mobile-value">{{ getValue(record, 'total') }}（元/个）</span>
                                        </div>
                                    </div>
                                </a-card>
                            </div>
                        </a-card>

                        <!-- 图表区 -->
                        <div class="canvas-div">
                            <a-card :bordered="false" class="chart-card">
                                <template #title>十日收入趋势</template>
                                <div ref="newIncomeChartRef" class="chart-box"></div>
                            </a-card>
                            <a-card :bordered="false" class="chart-card">
                                <template #title>十日新增授权数</template>
                                <div ref="newAuthChartRef" class="chart-box"></div>
                            </a-card>
                            <a-card :bordered="false" class="chart-card">
                                <template #title>十日新增代理数</template>
                                <div ref="newAgentChartRef" class="chart-box"></div>
                            </a-card>
                        </div>
                    </template>
                </div>
            </a-layout-content>
        </a-layout>
    </a-layout>
</template>
<script>
import { defineComponent, ref, computed } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import * as echarts from 'echarts';
import { isLogin, isNull, compareDates, openBox } from "@/utils/publicMethods"
import { message } from 'ant-design-vue'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
import { DollarOutlined, SafetyOutlined, TeamOutlined } from '@ant-design/icons-vue';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    components: {
        UserHead,
        HeadTop,
        DollarOutlined,
        SafetyOutlined,
        TeamOutlined,
    },
    data() {
        return {
            isDeveloper: 2,
            deveploerConf: {
                apiUrl: ""
            },
            deveploerData: {},
            select_includes: -1,
            everyDayData: {},
            newIncomeChart: null,
            newAuthChart: null,
            newAgentChart: null,
            statColumns: [
                { title: '#', dataIndex: 'label', key: 'label', width: 120, align: 'center' },
                { title: '今日', dataIndex: 'today', key: 'today', align: 'center' },
                { title: '昨日', dataIndex: 'yesterday', key: 'yesterday', align: 'center' },
                { title: '共计', dataIndex: 'total', key: 'total', align: 'center' },
            ],
        }
    },
    computed: {
        statDataList() {
            const d = this.deveploerData;
            if (!d.todayData && !d.yesterdayData && !d.totalData) return [];
            return [
                {
                    key: 'income',
                    label: '收益(元)',
                    icon: DollarOutlined,
                    iconColor: '#52c41a',
                    today: (d.todayData && d.todayData.authorIncome != null) ? d.todayData.authorIncome + '（元）' : '-',
                    yesterday: (d.yesterdayData && d.yesterdayData.authorIncome != null) ? d.yesterdayData.authorIncome + '（元）' : '-',
                    total: (d.totalData && d.totalData.authorIncome != null) ? d.totalData.authorIncome + '（元）' : '-',
                    raw: {
                        today: d.todayData?.authorIncome,
                        yesterday: d.yesterdayData?.authorIncome,
                        total: d.totalData?.authorIncome,
                    }
                },
                {
                    key: 'newAuth',
                    label: '新增授权',
                    icon: SafetyOutlined,
                    iconColor: '#1677ff',
                    today: (d.todayData && d.todayData.newAuth != null) ? d.todayData.newAuth + '（个）' : '-',
                    yesterday: (d.yesterdayData && d.yesterdayData.newAuth != null) ? d.yesterdayData.newAuth + '（个）' : '-',
                    total: (d.totalData && d.totalData.newAuth != null) ? d.totalData.newAuth + '（个）' : '-',
                },
                {
                    key: 'newAgent',
                    label: '新增代理',
                    icon: TeamOutlined,
                    iconColor: '#722ed1',
                    today: (d.todayData && d.todayData.newAgent != null) ? d.todayData.newAgent + '（个）' : '-',
                    yesterday: (d.yesterdayData && d.yesterdayData.newAgent != null) ? d.yesterdayData.newAgent + '（个）' : '-',
                    total: (d.totalData && d.totalData.newAgent != null) ? d.totalData.newAgent + '（个）' : '-',
                },
            ];
        }
    },
    methods: {
        getValue(record, field) {
            return record[field] != null ? record[field] : '-';
        },
        goApiUrl() {
            location.href = this.deveploerConf.apiUrl;
        },
        getInfo() {
            openLoading()
            const data = new FormData();
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.get(baseURL + '/dev/getInfo', { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        this.deveploerData = res.data.data
                        this.everyDayData = res.data.data.everyDayData;
                        this.drawEveryDayData();
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(res.data.data)
                    }
                    else {
                        message.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    message.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        getIncludesData(id) {
            openLoading()
            const data = new FormData();
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.get(baseURL + '/dev/getIncludesData?id=' + id, { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        this.deveploerData.todayData = res.data.data.todayData;
                        this.deveploerData.yesterdayData = res.data.data.yesterdayData;
                        this.deveploerData.totalData = res.data.data.totalData;
                        this.everyDayData = res.data.data.everyDayData;
                        this.drawEveryDayData();
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        this.openBox()
                    }
                    else {
                        message.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    message.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        drawEveryDayData() {
            let labels = [];
            let incomeDatas = [];
            let authDatas = [];
            let agentDatas = [];
            this.everyDayData.sort(compareDates);
            for (let i = 0; i < this.everyDayData.length; i++) {
                const element = this.everyDayData[i];
                const value = element.log;
                labels.push(element.date);
                incomeDatas.push(value.authorIncome);
                authDatas.push(value.newAuth);
                agentDatas.push(value.newAgent);
            }
            setTimeout(() => {
                this.drawGraphics(labels, incomeDatas, "收益(元)", 'income');
                this.drawGraphics(labels, authDatas, "新增授权(个)", 'auth');
                this.drawGraphics(labels, agentDatas, "新增代理(个)", 'agent');
            }, 200);
        },
        drawGraphics(labels, data, yTitle, type) {
            if (isNull(type) || !labels || !data || labels.length === 0 || data.length === 0 || labels.length !== data.length) {
                return;
            }

            const colorMap = {
                income: '#52c41a',
                auth: '#1677ff',
                agent: '#722ed1',
            };

            const refMap = {
                income: this.$refs.newIncomeChartRef,
                auth: this.$refs.newAuthChartRef,
                agent: this.$refs.newAgentChartRef,
            };

            const instanceMap = {
                income: 'newIncomeChart',
                auth: 'newAuthChart',
                agent: 'newAgentChart',
            };

            const el = refMap[type];
            if (!el) return;

            let chart = this[instanceMap[type]];
            if (chart) {
                chart.dispose();
            }

            chart = echarts.init(el);
            this[instanceMap[type]] = chart;

            const option = {
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: 'rgba(255,255,255,0.96)',
                    borderColor: '#f0f0f0',
                    borderWidth: 1,
                    textStyle: { color: '#374151', fontSize: 13 },
                    axisPointer: { type: 'line', lineStyle: { color: colorMap[type], type: 'dashed' } }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '8%',
                    top: '12%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: labels,
                    axisLine: { lineStyle: { color: '#e5e7eb' } },
                    axisLabel: { color: '#6b7280', fontSize: 12 },
                    axisTick: { show: false }
                },
                yAxis: {
                    type: 'value',
                    name: yTitle,
                    nameTextStyle: { color: '#9ca3af', fontSize: 12, padding: [0, 0, 0, 40] },
                    minInterval: 0,
                    axisLine: { show: false },
                    axisTick: { show: false },
                    axisLabel: { color: '#6b7280', fontSize: 12 },
                    splitLine: { lineStyle: { color: '#f3f4f6', type: 'dashed' } }
                },
                series: [{
                    data: data,
                    type: 'line',
                    smooth: true,
                    symbol: 'circle',
                    symbolSize: 6,
                    lineStyle: { width: 2.5, color: colorMap[type] },
                    itemStyle: { color: colorMap[type], borderWidth: 2, borderColor: '#fff' },
                    areaStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: colorMap[type] + '40' },
                            { offset: 1, color: colorMap[type] + '05' }
                        ])
                    }
                }]
            };

            chart.setOption(option);
        },
        resizeCharts() {
            ['newIncomeChart', 'newAuthChart', 'newAgentChart'].forEach(k => {
                if (this[k]) this[k].resize();
            });
        },
        destroyCharts() {
            ['newIncomeChart', 'newAuthChart', 'newAgentChart'].forEach(k => {
                if (this[k]) {
                    this[k].dispose();
                    this[k] = null;
                }
            });
        },
        isNull(text) {
            return isNull(text);
        }
    },
    mounted() {
        this.getInfo();
        window.addEventListener('resize', this.resizeCharts);
    },
    beforeUnmount() {
        this.destroyCharts();
        window.removeEventListener('resize', this.resizeCharts);
    }
})
</script>
